import * as React from "react";
import * as classnames from "classnames";
import Button from "../../Button";
import Icon from "../../Icon";
var CloseButton = function (_a) {
    var onClick = _a.onClick, _b = _a.variant, variant = _b === void 0 ? "dark" : _b, _c = _a.ariaLabel, ariaLabel = _c === void 0 ? "Close" : _c;
    var cx = classnames("wds-close", "wds-button--icon-only", "wds-button--" + variant);
    return (React.createElement(Button, { kind: "text", color: "secondary", size: "sm", className: cx, onClick: onClick, "aria-label": ariaLabel },
        React.createElement(Icon, null, "\u00E5")));
};
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/internal/CloseButton/CloseButton.js
// module id = 1797
// module chunks = 17